import * as React from 'react'
import { cn } from '@/lib/utils'

/*
 * Checkbox: an 18px visual control inside a 44x44px effective target.
 * The native input fills the target and is transparent; the drawn box after
 * it takes no pointer events, so a click anywhere in the target, the box
 * included, reaches the input. Props, `id` and ARIA attributes go to the
 * input, so `<label htmlFor>` keeps working. The accessible name is supplied
 * by the caller (aria-label) and, for row selection, must include the row
 * subject.
 */
function Checkbox({
  className,
  ...props
}: React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <span className="relative inline-flex size-11 shrink-0 items-center justify-center">
      <input
        type="checkbox"
        data-slot="checkbox"
        className={cn(
          'peer absolute inset-0 m-0 size-full cursor-pointer appearance-none opacity-0',
          'disabled:cursor-not-allowed',
          className,
        )}
        {...props}
      />
      <span
        aria-hidden="true"
        data-slot="checkbox-box"
        className={cn(
          'pointer-events-none relative size-[1.125rem] rounded-sm border border-line-strong bg-surface',
          'transition-colors',
          'peer-checked:border-action peer-checked:bg-action',
          'peer-checked:after:absolute peer-checked:after:left-1/2 peer-checked:after:top-1/2',
          "peer-checked:after:h-2.5 peer-checked:after:w-1.5 peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-[60%] peer-checked:after:rotate-45 peer-checked:after:border-b-2 peer-checked:after:border-r-2 peer-checked:after:border-[color:var(--vo-action-primary-foreground)] peer-checked:after:content-['']",
          'peer-disabled:opacity-50',
          'peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-focus',
        )}
      />
    </span>
  )
}

export { Checkbox }
